import { LANGUAGE_LABELS } from './labels';

const SUPPORTED_LANGUAGES = [
    'en',
    'ja',
    'vi',
];

export const SUPPORTED_LANGUAGE_OPTIONS = SUPPORTED_LANGUAGES.map((language) => ({
    label: LANGUAGE_LABELS[language],
    value: language,
}));